/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AiUserFeedbackControllerFindAllQueryResponse, AiUserFeedbackControllerFindAllQueryParams, AiUserFeedbackControllerFindAll401, AiUserFeedbackControllerFindAll403 } from "../../models/aiUserFeedbackController/AiUserFeedbackControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { aiUserFeedbackControllerFindAll } from "../../clients/ai-user-feedbackService/aiUserFeedbackControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const aiUserFeedbackControllerFindAllQueryKey = (params: AiUserFeedbackControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/ai-user-feedback'
}, ...(params ? [params] : [])] as const;
export type AiUserFeedbackControllerFindAllQueryKey = ReturnType<typeof aiUserFeedbackControllerFindAllQueryKey>;
export function aiUserFeedbackControllerFindAllQueryOptions(params?: AiUserFeedbackControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = aiUserFeedbackControllerFindAllQueryKey(params);
  return queryOptions<AiUserFeedbackControllerFindAllQueryResponse, ResponseErrorConfig<AiUserFeedbackControllerFindAll401 | AiUserFeedbackControllerFindAll403>, AiUserFeedbackControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return aiUserFeedbackControllerFindAll(params, config);
    }
  });
}

/**
 * @summary List AI user feedback for the current principal
 * {@link /api/v1/ai-user-feedback}
 */
export function useAiUserFeedbackControllerFindAll<TData = AiUserFeedbackControllerFindAllQueryResponse, TQueryData = AiUserFeedbackControllerFindAllQueryResponse, TQueryKey extends QueryKey = AiUserFeedbackControllerFindAllQueryKey>(params?: AiUserFeedbackControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<AiUserFeedbackControllerFindAllQueryResponse, ResponseErrorConfig<AiUserFeedbackControllerFindAll401 | AiUserFeedbackControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? aiUserFeedbackControllerFindAllQueryKey(params);
  const query = useQuery({
    ...aiUserFeedbackControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AiUserFeedbackControllerFindAll401 | AiUserFeedbackControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}